<template>
	<div class="header-bottom-wrap" :class="{ storysetting: storySetting || storymodal}">
		<div class="container">
			<div class="header-bottom">
				<ul class="hb-nav-left">
					<li>
						<a href="#" class="navitem">Draft Saved</a>
					</li>
					<li>
                        <router-link to="/import-text" class="navitem" id="v-step-1">
                            Import Text
                        </router-link>
					</li>
				</ul>

				<ul class="hb-nav-right">
					<li>
		                <base-dropdown class="navitem dropdown-menu-center">
		                    <div class="profile d-flex align-items-center toggle-dot" slot="title">
								<img src="../../assets/icon/more-horizontal.svg" alt="more-horizontal">
		                    </div>

		                    <template>
		                        <router-link to="/notificatons/1" class="dropdown-item ">
		                            <p>Drafts</p>
		                        </router-link>
		                        <a href="#" class="dropdown-item" @click="storySettingModal()">
		                            <p>Edit Story Settings</p>
		                        </a>
		                        <router-link to="/notificatons/3" class="dropdown-item ">
		                            <p>Story Ideas</p>
		                        </router-link>
		                        <router-link to="/notificatons/3" class="dropdown-item ">
		                            <p>Delete Story</p>
		                        </router-link>
		                        <a href="#" class="dropdown-item"  @click="showModals()">
		                            <p>Add to Series</p>
		                        </a>
		                        <a href="#" class="dropdown-item d-flex space-between">
		                            <p>All writting Suggestions</p>
		                            <toggle-button style="margin-left: 5px;" :color="{checked: '#DAF7F7', unchecked: '#E9EBEF'}" :switch-color="{checked: '#00C6C6', unchecked: '#A6B2C0'}" :width="38" :height="22" v-model="suggestions"/>
		                        </a>
		                        <a href="#" class="dropdown-item d-flex space-between">
		                            <p>Spellcheck</p>
		                            <toggle-button :color="{checked: '#DAF7F7', unchecked: '#E9EBEF'}" :switch-color="{checked: '#00C6C6', unchecked: '#A6B2C0'}" :width="38" :height="22" v-model="spellcheck"/>
		                        </a>
		                        <div class="border-bottom"></div>
		                        <router-link to="/notificatons/3" class="dropdown-item ">
		                            <p>200 words</p>
		                        </router-link>
		                        <router-link to="/notificatons/3" class="dropdown-item ">
		                            <p>- 5 minute read</p>
		                        </router-link>

		                    </template>
		                </base-dropdown>
					</li>
					<li>
						<a href="#" class="navitem btn">Preview</a>
					</li>
					<li>
						<a href="#" class="navitem btn active" @click="storyModal()">Publish</a>
					</li>
				</ul>
			</div>
		</div>


		<!--
		%%%%%%%%%%%% Modal Area %%%%%%%%%%
		-->


	    <!-- Edit Story Settings modal start -->
	    <modal v-if="storySetting" class="importText seriesModal" id="storySetting">

	    	<div slot="closeModal" @click="closeModal()">
	    		<i class="fas fa-times-circle"></i>
	    	</div>
	        <h3 slot="header">
	        	<div class="crossModal" @click="closeModal()">
		    		<img src="../../assets/icon/group-10.svg" alt="close" />
		    	</div>
		    </h3>
	        <div slot="body">
	          <div class="from-group">
	          	<label for="title">Title</label>
	          	<input type="text" placeholder="Magic of Numbers" class="form-control" id="title" />
	          </div>

	          <div class="from-group">
	          	<label for="tag">Tags</label>
	          	<vue-tags-input class="tag-control"
			      v-model="storyTagSelected"
			      :tags="storyTag"
			      @tags-changed="newTags => tags = newTags"
			      add-on-key="['13', ':']"
			      @delete-on-backspace="true"
			    />
	          </div>

	          <div class="from-group">
	          	<label for="tag" style="font-weight: 400">SUGGESTED TAGS</label>
	          	<!-- <input type="text" placeholder="Magic of Numbers" class="form-control" id="tag" /> -->
	          	<div class="suggestedTag">
	          		<span>drama</span>
	          		<span>funny</span>
	          		<span>poem</span>
	          		<span>doodle</span>
	          		<span>love</span>
	          	</div>
	          </div>

	          <div class="from-group">
	          	<label for="tag">Description</label>
	          	<!-- <input type="text" placeholder="Magic of Numbers" class="form-control" id="tag" /> -->
	          	<textarea class="form-control" placeholder="A story about numbers, love and the drama of a great time."></textarea>
	          </div>

	          <div class="from-group shareDraft">
	          	<label for="tag">Share Draft</label>
	          	<!-- <input type="text" placeholder="Magic of Numbers" class="form-control" id="tag" /> -->
	          	<p>
	          		<a href="#">https://commaful.com/play/wethedreamers/</a>
	          		<span>Copy</span>
	          	</p>
	          </div>

	          
	          <div class="from-group creditSelect">
				<label class="typo__label">Credit Collaborators:</label>
				  <multiselect v-model="value" placeholder="Select..." label="title" track-by="title" :options="options" :option-height="104" :show-labels="false">
				    <template slot="singleLabel" slot-scope="props">
				    	<img class="option__image" src="../../assets/images/sydney.svg" alt="img">
				    	<span class="option__title">{{ props.option.title }}</span>
					</template>
				    <template slot="option" slot-scope="props">
				    	<img class="option__image" src="../../assets/images/sydney.svg" alt="img">
				        <span class="option__title">{{ props.option.title }}</span>
				    </template>
				  </multiselect>
	          </div>

	        </div>
	        <div slot="footer" class="seriesFooter">       
	            <button class="save-btn" @click="saveSetting()">Done</button>
	        </div>
	    </modal>
	    <!-- Edit Story Settings modal end -->

	    <!-- Add to Series modal start -->
	    <modal v-if="showModal" @close="showModal = false" class="importText seriesModal" @click="$emit('close')">
	    	<div slot="closeModal" @click="closeAllModal()">
	    		<i class="fas fa-times-circle"></i>
	    	</div>
	        <h3 slot="header">Choose a series to add this to:</h3>
	        <div slot="body">
	          <ul class="seriesList">
	            <li v-for="(data, index) in seriesList" :key="index">
	            	<input name="series" type="radio" :id="data.id" v-if="data.id==1" checked>
	            	<input name="series" type="radio" :id="data.id" v-else>
	            	<span class="checkmark"></span>
	            	<label :for="data.id">{{data.title}} <span>({{data.total}} stories)</span></label>
	            </li>
	          </ul>
	          <a href="#" class="addNewSeries"><img src="../../assets/icon/plus-icon.svg" alt="svg">Create a new series</a>
	        </div>
	        <div slot="footer" class="seriesFooter">       
	            <button class="save-btn" @click="seriesSave()">Done</button>
	        </div>
	    </modal>
	    <!-- Add to Series modal end -->

	    <!-- storymodal modal start -->
	    <modal v-if="storymodal" class="importText seriesModal" id="storySetting">

	    	<div slot="closeModal" @click="closeAllModal()">
	    		<i class="fas fa-times-circle"></i>
	    	</div>
	        <h3 slot="header">
	        	<div class="crossModal" @click="closeSettModal()">
		    		<img src="../../assets/icon/group-10.svg" alt="close" />
		    	</div>

		    </h3>
	        <div slot="body">
	          <div class="storyTitle">
	          	<h2>Your story is now live!</h2>
	          	<p>Add a desctiption and some tags to help your story get discovered.</p>
	          </div>

	          <div class="from-group">
	          	<label for="tag">Tags</label>
	          	<!-- <input type="text" placeholder="Magic of Numbers" class="form-control" id="tag" /> -->
	          	<vue-tags-input class="tag-control"
			      v-model="storyTagSelected"
			      :tags="storyTag"
			      @tags-changed="newTags => tags = newTags"
			      add-on-key="[13, ':']"
			      @delete-on-backspace="true"
			    />
	          </div>

	          <div class="from-group">
	          	<label for="tag" style="font-weight: 400">SUGGESTED TAGS</label>
	          	<!-- <input type="text" placeholder="Magic of Numbers" class="form-control" id="tag" /> -->
	          	<div class="suggestedTag">
	          		<span>drama</span>
	          		<span>funny</span>
	          		<span>poem</span>
	          		<span>doodle</span>
	          		<span>love</span>
	          	</div>
	          </div>

	          <div class="from-group">
	          	<label for="tag">Description</label>
	          	<!-- <input type="text" placeholder="Magic of Numbers" class="form-control" id="tag" /> -->
	          	<textarea class="form-control" placeholder="A story about numbers, love and the drama of a great time."></textarea>
	          </div>


	        </div>
	        <div slot="footer" class="seriesFooter">       
	            <button class="save-btn" @click="saveStory()">Done</button>
	        </div>
	    </modal>
	    <!-- storymodal modal end -->

	    <!-- Add to Series modal start -->
	    <modal v-if="shareTwitt" @close="shareTwitt = false" class="importText storyModal" @click="$emit('close')">
	    	<div slot="closeModal" @click="closeAllModal()">
	    		<i class="fas fa-times-circle"></i>
	    	</div>
	        <h3 slot="header" class="text-center">Want to get featured? <br> Share your story to Twitter</h3>
	        <div slot="body">
	          <div class="shareFrame">
	          	<div class="sahreUser">
	          		<img src="../../assets/images/avatar.png" alt="avatar" />
	          		<div class="shareUserName">
	          			<p>Dara Adhelia</p>
	          			<span>@daracakeep</span>
	          		</div>
	          	</div>
	          	<div class="twitImgWrap">
	          		<img src="../../assets/images/twitte.jpg" alt="twitte" />
	          		<div class="twitContent">
	          			<div class="twittAuthor">
			          		<img src="../../assets/images/avatar.png" alt="avatar" />
			          		<div class="shareUserName">
			          			<p>Jagat Shahidullah</p>
			          			<span>Worthless writer</span>
		          			</div>
	          			</div>
	          			<div class="twittBtn">
	          				<ul>
	          					<li class="active"><i class="fas fa-heart"></i> <span>134</span></li>
	          					<li><i class="fas fa-retweet"></i> <span>14</span></li>
	          					<li><i class="far fa-comment"></i> <span>14</span></li>
	          				</ul>
	          			</div>
	          		</div>
	          	</div>
	          </div>
	        </div>
	        <div slot="footer" class="seriesFooter">       
	            <button class="save-btn" @click="tweetShare()">Let’s do it!</button>
	        </div>
	    </modal>
	    <!-- Add to Series modal end -->

		<!--
		%%%%%%%%%%%% Modal Area %%%%%%%%%%
		-->

	</div>
</template>



<script>

import Multiselect from 'vue-multiselect';
import VueTagsInput from '@johmun/vue-tags-input';

export default {
  components: { Multiselect, VueTagsInput },
  name: "header-bottom",
  data() {
  	return {
  		suggestions:true,
  		spellcheck:false,
  		series:'1',

  		/*
  		*	"Edit Story Settings" modal data
  		*/
  		storySetting:false,
	    storyTagSelected: '',
	    storyTag: [],
	    // Credit Collaborators select box dat
		value: { title: 'Sydney', img: 'sydney.svg' },
	    options: [
	        { title: 'Sydney', img: 'sydney.svg' },
	        { title: 'Sydney Liu', img: 'sydney.svg' },
	        { title: 'Sydneykedney', img: 'sydney.svg' }
	    ],



  		/*
  		*	"Add to Series" modal data
  		*/
  		showModal:false,
  		seriesSelect:'1',
  		seriesList: [
  			{
  				id:1,
  				title: 'My Poetry Collection',
  				total: 3
  			},
  			{
  				id:2,
  				title: 'Barney the Dinosaur Killer',
  				total: 2
  			},
  			{
  				id:3,
  				title: 'The Wrath of the Potatoes Series',
  				total: 2
  			},
  			{
  				id:4,
  				title: 'Dragon Slayers',
  				total: 18
  			},
  			{
  				id:5,
  				title: 'The Adventures of Chandler Jr and th…',
  				total: 9
  			},
  		],


  		/*
  		*	"story publis" modal data
  		*/
  		storymodal:false,
  		shareTwitt:false,
  	}
  },

  methods: {
  	closeAllModal() {
  		this.storySetting = false;
  		this.showModal = false;
  		this.storymodal = false;
  		this.shareTwitt = false;
  	},
  	showModals() {
  		this.showModal = true;
  	},
  	seriesSave() {
  		this.showModal = false;
  	},

  	storySettingModal() {
  		this.storySetting = true;
  	},
  	saveSetting() {
  		this.storySetting = false;
  	},
  	closeModal() {
  		this.storySetting = false;
  	},
	storyModal() {
		this.storymodal=true;
	},
	saveStory() {
		this.storymodal=false;
		this.shareTwitt=true;
	},
	closeSettModal() {
		this.storymodal=false;
	},
	tweetShare() {
		this.shareTwitt=false;
	},
	selectedSeries(data) {
		this.seriesSelect=data.id
	},
  }
}


</script>



<style scoped>
	@import '../../assets/css/header-bottom.css';
	.vue-js-switch .v-switch-core .v-switch-button[data-v-25adc6c0] {
	    display: block;
	    position: absolute;
	    overflow: hidden;
	    top: 0;
	    left: 0;
	    border-radius: 100%;
	    background-color: #fff;
	    z-index: 2;
	}

	.toggle-dot>img{
		padding: 20px 10px;
	}

</style>